var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { learningLounge } from "../../../../api";
import { utilities } from "../../../../utilities/utilities";
import { Element } from "../../../../element/element";
import { Spinner } from "../../../../component/spinner";
import { API } from "../../../../api";
export var search = {
    element: null,
    inputWrapper: null,
    searchPhraseInput: null,
    searchPhraseIdInput: null,
    commodityIdInput: null,
    searchButton: null,
    resultsElement: null,
    results: [],
    selectedIndex: -1,
    spinner: null,
    get searchPhrase() {
        var _a, _b, _c;
        return (_c = (_b = (_a = search.searchPhraseInput) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : "";
    },
    get searchPhraseId() {
        var _a;
        return ((_a = search.searchPhraseIdInput) === null || _a === void 0 ? void 0 : _a.value) ? Number(search.searchPhraseIdInput.value) : null;
    },
    get commodityId() {
        var _a;
        return ((_a = search.commodityIdInput) === null || _a === void 0 ? void 0 : _a.value) ? Number(search.commodityIdInput.value) : null;
    },
    composeResultsElement: function () {
        search.resultsElement = utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            <ul id=\"auto-complete-results\" class=\"position-absolute  px-2 pb-3 pt-0 rounded-bottom bg-gradient d-flex flex-column gap-1 overflow-auto w-100\" style=\"list-style:none; top:41px; background:#212529 !important; z-index:9991\">\n                ", "\n            </ul>\n        "], ["\n            <ul id=\"auto-complete-results\" class=\"position-absolute  px-2 pb-3 pt-0 rounded-bottom bg-gradient d-flex flex-column gap-1 overflow-auto w-100\" style=\"list-style:none; top:41px; background:#212529 !important; z-index:9991\">\n                ", "\n            </ul>\n        "])), new Element({
            composer: {
                content: utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                            <div role=\"button\" class=\"pe-auto d-none position-absolute top-0 end-0\">\n                                <a class=\"fa-solid fa-times text-decoration-none text-white x1\" style=\"color:#fff;padding:10px;\"></a>\n                            </div>\n                        "], ["\n                            <div role=\"button\" class=\"pe-auto d-none position-absolute top-0 end-0\">\n                                <a class=\"fa-solid fa-times text-decoration-none text-white x1\" style=\"color:#fff;padding:10px;\"></a>\n                            </div>\n                        "])))
            },
            events: {
                click: function () { return search.clear(); }
            }
        }).render());
        search.resultsElement.style.maxHeight = (window.innerHeight * 0.9) + 'px';
    },
    removeResultsElement: function () {
        if (!search.resultsElement)
            return;
        search.resultsElement.remove();
        search.resultsElement = null;
    },
    initUpDownKeys: function (e) {
        var _a, _b, _c;
        if (!((_a = search.results) === null || _a === void 0 ? void 0 : _a.length))
            return;
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp")
            return;
        search.selectedIndex = e.key === "ArrowDown"
            ? (search.selectedIndex + 1) % search.results.length
            : (search.selectedIndex - 1 + search.results.length) % search.results.length;
        (_b = search.resultsElement) === null || _b === void 0 ? void 0 : _b.querySelectorAll('li').forEach(function (li, i) { return li.classList.toggle("selected", i === search.selectedIndex); });
        var selected = (_c = search.resultsElement) === null || _c === void 0 ? void 0 : _c.querySelectorAll('li')[search.selectedIndex];
        var link = selected === null || selected === void 0 ? void 0 : selected.querySelector("a");
        if (link && search.searchPhrase) {
            console.log(search.selectedIndex, link.textContent);
            setTimeout(function () {
                var _a, _b, _c, _d, _e, _f, _g;
                search.searchPhraseInput.value = (_b = (_a = link.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
                search.searchPhraseIdInput.value = (_d = (_c = link.dataset.searchPhraseId) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : "";
                search.commodityIdInput.value = (_g = (_f = (_e = link.dataset) === null || _e === void 0 ? void 0 : _e.commodityId) === null || _f === void 0 ? void 0 : _f.trim()) !== null && _g !== void 0 ? _g : "";
            }, 1);
        }
        e.preventDefault();
    },
    suggest: function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // skip arrow keys
                    if (e.key === 'ArrowDown' || e.key === 'ArrowUp')
                        return [2 /*return*/];
                    if (!search.resultsElement) {
                        search.composeResultsElement();
                        (_a = search.inputWrapper) === null || _a === void 0 ? void 0 : _a.prepend(search.resultsElement);
                    }
                    if (!search.searchPhrase) {
                        search.removeResultsElement();
                        search.spinner = null;
                        return [2 /*return*/];
                    }
                    // kill existing spinner if present
                    (_b = search === null || search === void 0 ? void 0 : search.spinner) === null || _b === void 0 ? void 0 : _b.remove();
                    search.spinner = new Spinner({
                        composer: {
                            classes: {
                                border: 'spinner-border-sm'
                            }
                        }
                    }).render();
                    (_c = search.resultsElement) === null || _c === void 0 ? void 0 : _c.appendChild(search.spinner);
                    return [4 /*yield*/, new API({
                            url: "".concat(learningLounge, "/Search/GetAutoCompSuggestions/?searchPhrase=").concat(encodeURIComponent(search.searchPhrase)),
                            events: {
                                success: function (data) {
                                    var _a;
                                    search.results = data;
                                    (_a = search.spinner) === null || _a === void 0 ? void 0 : _a.remove();
                                    search.spinner = null;
                                    search.renderResults();
                                }
                            }
                        }).invoke()];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    clearResults: function () {
        var _a, _b, _c, _d;
        (_b = (_a = search.resultsElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll('li')) === null || _b === void 0 ? void 0 : _b.forEach(function (li) { return li.remove(); });
        (_d = (_c = search.resultsElement) === null || _c === void 0 ? void 0 : _c.querySelector('.no-results')) === null || _d === void 0 ? void 0 : _d.remove();
    },
    renderResults: function () {
        var _a, _b;
        search.clearResults();
        if (!search.results.length) {
            (_a = search.resultsElement) === null || _a === void 0 ? void 0 : _a.appendChild(utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                <div class=\"no-results small\">No results found</div>\n            "], ["\n                <div class=\"no-results small\">No results found</div>\n            "]))));
        }
        else {
            var _loop_1 = function (item) {
                (_b = search.resultsElement) === null || _b === void 0 ? void 0 : _b.appendChild(new Element({
                    composer: {
                        content: utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                            <li class=\"rounded overflow-hidden d-flex align-items-center p-0 flex-shrink-0\">\n                                <a \n                                    class=\"p-2 w-100 text-decoration-none\"\n                                    style=\"color:inherit !important\"\n                                    data-search-phrase-id=\"", "\" \n                                    data-commodity-id=", "\n                                >\n                                    ", "\n                                </a>\n                            </li>\n                        "], ["\n                            <li class=\"rounded overflow-hidden d-flex align-items-center p-0 flex-shrink-0\">\n                                <a \n                                    class=\"p-2 w-100 text-decoration-none\"\n                                    style=\"color:inherit !important\"\n                                    data-search-phrase-id=\"", "\" \n                                    data-commodity-id=", "\n                                >\n                                    ", "\n                                </a>\n                            </li>\n                        "])), item.searchPhraseId, item.commodityId, item.commodityTitle)
                    },
                    events: {
                        click: function () {
                            var _a, _b;
                            return search.submit((_a = item.searchPhraseId) === null || _a === void 0 ? void 0 : _a.toString(), (_b = item === null || item === void 0 ? void 0 : item.commodityId) === null || _b === void 0 ? void 0 : _b.toString(), item === null || item === void 0 ? void 0 : item.commodityTitle);
                        }
                    }
                }).render());
            };
            for (var _i = 0, _c = search.results; _i < _c.length; _i++) {
                var item = _c[_i];
                _loop_1(item);
            }
        }
    },
    submit: function (searchPhraseId, commodityId, searchPhrase) {
        var _a, _b, _c, _d, _e;
        search.searchPhraseIdInput.value = searchPhraseId !== null && searchPhraseId !== void 0 ? searchPhraseId : (_a = search.searchPhraseId) === null || _a === void 0 ? void 0 : _a.toString();
        search.commodityIdInput.value = commodityId !== null && commodityId !== void 0 ? commodityId : (_b = search.commodityId) === null || _b === void 0 ? void 0 : _b.toString();
        search.searchPhraseInput.value = (_c = searchPhrase !== null && searchPhrase !== void 0 ? searchPhrase : search.searchPhrase) !== null && _c !== void 0 ? _c : (_d = search.searchPhraseInput) === null || _d === void 0 ? void 0 : _d.value;
        (_e = search.element) === null || _e === void 0 ? void 0 : _e.submit();
    },
    clear: function () {
        search.removeResultsElement();
        search.searchPhraseInput.value = '';
        search.selectedIndex = 0;
    },
    render: function () {
        var _this = this;
        search.searchPhraseInput = new Element({
            composer: {
                content: utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                    <input id=\"searchPhrase\" name=\"searchPhrase\" type=\"text\" class=\"form-control rounded-0 rounded-start\" placeholder=\"learninglounge.com : search\" autocomplete=\"off\" style=\"\">\n                "], ["\n                    <input id=\"searchPhrase\" name=\"searchPhrase\" type=\"text\" class=\"form-control rounded-0 rounded-start\" placeholder=\"learninglounge.com : search\" autocomplete=\"off\" style=\"\">\n                "]))),
            },
            events: {
                focus: function () {
                    if (!search.searchPhrase)
                        search.removeResultsElement();
                },
                keydown: function (e) { return search.initUpDownKeys(e); }
            }
        }).render();
        search.searchButton = new Element({
            composer: {
                content: utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                    <a class=\"text-dark fa-light h-100 d-flex justify-content-center align-items-center fa-search p-2\" style=\"cursor:pointer; text-decoration:none\"></a>\n                "], ["\n                    <a class=\"text-dark fa-light h-100 d-flex justify-content-center align-items-center fa-search p-2\" style=\"cursor:pointer; text-decoration:none\"></a>\n                "])))
            },
            events: {
                click: function (e) {
                    e.preventDefault();
                    search.submit();
                }
            }
        }).render();
        search.searchPhraseIdInput = utilities.html(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            <input id=\"searchPhraseId\" name=\"searchPhraseId\" type=\"hidden\">\n        "], ["\n            <input id=\"searchPhraseId\" name=\"searchPhraseId\" type=\"hidden\">\n        "])));
        search.commodityIdInput = utilities.html(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            <input id=\"commodityId\" name=\"commodityId\" type=\"hidden\">\n        "], ["\n            <input id=\"commodityId\" name=\"commodityId\" type=\"hidden\">\n        "])));
        search.inputWrapper = utilities.html(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n            <div id=\"siteSearch\" class=\"d-flex w-100\" style=\"position:relative;\">\n                ", "\n                ", "\n                ", "\n                <div class=\" bg-light rounded-end overflow-hidden\">\n                    ", "\n                </div>\n            </div>\n        "], ["\n            <div id=\"siteSearch\" class=\"d-flex w-100\" style=\"position:relative;\">\n                ", "\n                ", "\n                ", "\n                <div class=\" bg-light rounded-end overflow-hidden\">\n                    ", "\n                </div>\n            </div>\n        "])), search.searchPhraseInput, search.searchPhraseIdInput, search.commodityIdInput, search.searchButton);
        var lastSearchValue = "";
        search.element = new Element({
            composer: {
                content: utilities.html(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                    <form name=\"siteSearch\" action=\"", "/search/siteSearch\" class=\"\" id=\"siteSearchForm\" method=\"post\" role=\"search\" style=\"max-width:100%\">\n                        <div class=\"d-flex\" style=\"width:400px; max-width:100%\">\n                            ", "\n                        </div>\n                    </form>\n                "], ["\n                    <form name=\"siteSearch\" action=\"", "/search/siteSearch\" class=\"\" id=\"siteSearchForm\" method=\"post\" role=\"search\" style=\"max-width:100%\">\n                        <div class=\"d-flex\" style=\"width:400px; max-width:100%\">\n                            ", "\n                        </div>\n                    </form>\n                "])), learningLounge, search.inputWrapper)
            },
            events: {
                //todo confusing up/ down arrow keys
                keyup: function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var val;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                val = search.searchPhraseInput.value;
                                if (val === lastSearchValue)
                                    return [2 /*return*/]; // only run if input text changed
                                lastSearchValue = val;
                                if (e.key === 'ArrowDown' || e.key === 'ArrowUp')
                                    return [2 /*return*/];
                                return [4 /*yield*/, search.suggest(e)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            }
        }).render();
        document.addEventListener('click', search.clear);
        return search.element;
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//  await $$.api({
//     url : `https://localhost:44309/Search/GetAutoCompSuggestions/?searchPhrase=${encodeURIComponent(query)}`,
//         events : {
//         success : (data) => {
//             updateDiv(data);
//         }
//     }
// }).invoke()
// Fetch suggestions
// async function retrieveData(path: string, query: string): Promise<void> {
//   try {
//     const response = await fetch(`${path}?searchPhrase=${encodeURIComponent(query)}`, {
//     //   method: "GET",
//     //   mode: "cors", // 
//     //   headers: {
//     //     "Accept": "application/json",
//     //   },
//     });
//     if (!response.ok) throw new Error(`Server returned ${response.status}`);
//     const data: SearchResult[] = await response.json();
//     updateDiv(data);
//   } catch (err) {
//     console.error("Error fetching data:", err);
//   }
// }
// Handle search input suggestions
//todo INTERFACE FOR RESULT FROM APICALL, DIFFERENT TO ABOVE
// Hide search results
// function hideSearchResult(): void {
//     const results = document.getElementById("auto-complete-results");
//     if (results) results.remove();
//     // siteSearchDefault();
//      const searchPhrase = document.getElementById("searchPhrase") as HTMLInputElement | null;
//   if (searchPhrase) {
//     // searchPhrase.placeholder = "learninglounge.com: search";
//     // searchPhrase.style.letterSpacing = ".4em";
//     searchPhrase.value = "";
//   }
//     document.removeEventListener("click", hideSearchResult);
// }
// async function siteSearchSuggest(e: KeyboardEvent){
//     const eventSource = e.which || e.keyCode;
//     if (eventSource === 40 || eventSource === 38) return;
//     const siteSearch = document.getElementById("siteSearch");
//     const searchPhraseInput = document.getElementById("searchPhrase") as HTMLInputElement | null;
//     if (!siteSearch || !searchPhraseInput) return;
//     let results = document.getElementById("auto-complete-results") as HTMLUListElement | null;
//     if(!results){
//         results = utilities.html`
//             <ul id="auto-complete-results" class="position-absolute  px-2 py-3 rounded-bottom bg-gradient d-flex flex-column gap-1 overflow-auto w-100" style="list-style:none; top:41px; background:rgba(0,0,0,0.9)">
//             </ul>
//         `;
//         results.style.maxHeight = (window.innerHeight * 0.9) + 'px';
//         siteSearch.prepend(results);
//     }
//   if (searchPhraseInput.value.trim() !== "") {
//         // searchPhraseInput.style.letterSpacing = ".1em";
//        await $$.api({
//             url : `https://localhost:44309/Search/GetAutoCompSuggestions/?searchPhrase=${encodeURIComponent(searchPhraseInput.value)}`,
//                 events : {
//                 success : (data) => {
//                     updateDiv(data);
//                 }
//             }
//         }).invoke()
//         // retrieveData("https://localhost:44309/Search/GetAutoCompSuggestions/", searchPhraseInput.value);
//   } else {
//         clearDivs();
//   }
// }
// Reset to default state
// function siteSearchDefault(): void {
//   const searchPhrase = document.getElementById("searchPhrase") as HTMLInputElement | null;
//   if (searchPhrase) {
//     searchPhrase.placeholder = "learninglounge.com: search";
//     searchPhrase.style.letterSpacing = ".4em";
//     searchPhrase.value = "";
//   }
// }
// Submit form
// function siteSearchSubmit(searchPhraseId: number, commodityId: number, searchPhrase?: string): void {
//   const form = document.forms["siteSearch"];
//   const phraseIdElem = document.getElementById("searchPhraseId") as HTMLInputElement;
//   const commodityElem = document.getElementById("commodityId") as HTMLInputElement;
//   const phraseElem = document.getElementById("searchPhrase") as HTMLInputElement;
//   if (!form || !phraseIdElem || !commodityElem || !phraseElem) return;
//   phraseIdElem.value = searchPhraseId?.toString();
//   commodityElem.value = commodityId?.toString();
//   phraseElem.value = searchPhrase ?? phraseElem.value;
//   form.submit();
// }
// Clear search UI
// function siteSearchClear(): void {
//   const searchPhrase = document.getElementById("searchPhrase") as HTMLInputElement | null;
//   if (searchPhrase) {
//     searchPhrase.placeholder = "";
//     searchPhrase.style.letterSpacing = ".4em";
//     searchPhrase.removeEventListener("keydown", handleNavigation);
//   }
//   const results = document.getElementById("auto-complete-results");
//   if (results) results.remove();
// }
// Update autocomplete list
// function updateDiv(data: SearchResult[]): void {
//     console.log(data)
//     clearDivs();
//     const results = document.getElementById("auto-complete-results");
//     if (!results) return;
//     if (data.length > 0) {
//         if (!document.getElementById("search-close")) {
//         const closeDiv = document.createElement("div");
//         closeDiv.id = "search-close";
//         closeDiv.classList.add('position-absolute', 'top-0', 'end-0')
//         closeDiv.style.cssText = "cursor:pointer;";
//         closeDiv.innerHTML = `<a class="fa-solid fa-times text-decoration-none text-white x1" style="color:#fff;padding:10px;"></a>`;
//         results.appendChild(closeDiv);
//         document.addEventListener("click", hideSearchResult);
//         }
//     } else {
//         const close = document.getElementById("search-close");
//         if (close) close.remove();
//     }
//     for (const item of data) {
//         const li = document.createElement("li");
//         li.classList.add('p-1', 'rounded');
//         const a = document.createElement("a");
//         a.dataset.searchPhraseId = item.searchPhraseId.toString();
//         a.dataset.commodityId = item?.commodityId?.toString();
//         a.textContent = item.commodityTitle;
//         a.onclick = () => siteSearchSubmit(item.searchPhraseId, item?.commodityId, item.commodityTitle);
//         li.appendChild(a);
//         results.appendChild(li);
//     }
//     initialiseResultNavigation();
// }
// Remove existing autocomplete results
// function clearDivs(): void {
//   const results = document.getElementById("auto-complete-results");
//   if (results) {
//     results.querySelectorAll("li").forEach((li) => li.remove());
//   }
// }
// Handle keyboard navigation through results
// function initialiseResultNavigation(): void {
//   const searchPhrase = document.getElementById("searchPhrase") as HTMLInputElement | null;
//   const results = document.getElementById("auto-complete-results");
//   if (!searchPhrase || !results) return;
//   searchPhrase.removeEventListener("keydown", handleNavigation);
//   searchPhrase.addEventListener("keydown", handleNavigation);
// }
// let selectedIndex = -1;
// function handleNavigation(e: KeyboardEvent): void {
//     const results = document.querySelectorAll<HTMLLIElement>("#auto-complete-results > li");
//     const searchPhrase = document.getElementById("searchPhrase") as HTMLInputElement | null;
//     if (!searchPhrase || results.length === 0) return;
//         if (e.which === 40) { // down arrow
//             selectedIndex = (selectedIndex + 1) % results.length;
//         } else if (e.which === 38) { // up arrow
//             selectedIndex = (selectedIndex - 1 + results.length) % results.length;
//         } else {
//         return;
//     }
//     results.forEach((li, i) => li.classList.toggle("selected", i === selectedIndex));
//     const selected = results[selectedIndex];
//     const link = selected.querySelector("a");
//     if (link && searchPhrase) {
//         searchPhrase.value = link.textContent ?? "";
//         (document.getElementById("searchPhraseId") as HTMLInputElement).value = link.dataset.searchPhraseId ?? "";
//         (document.getElementById("commodityId") as HTMLInputElement).value = link.dataset?.commodityId ?? "";
//     }
//   e.preventDefault();
// }
